import { render, staticRenderFns } from "./FabAtalhos.vue?vue&type=template&id=2ab528ae&scoped=true"
import script from "./FabAtalhos.vue?vue&type=script&lang=js"
export * from "./FabAtalhos.vue?vue&type=script&lang=js"
import style0 from "./FabAtalhos.vue?vue&type=style&index=0&id=2ab528ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab528ae",
  null
  
)

export default component.exports